import { DEFAULT_MIDDLE_DIALOG_WIDTH } from '@abb-procure/constants';
import { IdNameCodeModel } from '@abb-procure/data';
import { Injectable, inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import type {
  MdfDialog,
  MdfDialogData,
} from '../components/mdf-dialog/mdf-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class MdfDialogService {
  private readonly dialog = inject(MatDialog);

  /**
   * Show a dialog to select the MDF code for an RfRFQ entity.
   */
  async openMdfDialog(
    projectId: string,
    mdfCode?: IdNameCodeModel,
  ): Promise<MatDialogRef<MdfDialog, IdNameCodeModel>> {
    const module =
      await import('../components/mdf-dialog/mdf-dialog.component');

    return this.dialog.open<MdfDialog, MdfDialogData, IdNameCodeModel>(
      module.MdfDialog,
      {
        width: DEFAULT_MIDDLE_DIALOG_WIDTH,
        data: {
          projectId,
          mdfCode,
        },
        panelClass: ['mdf-dialog'],
      },
    );
  }
}
